import React from 'react';
import { Modal, Button } from 'react-bootstrap';

interface ConfirmationModalProps {
  show: boolean;
  message: string;
  object?: any;
  title?: string;
  yesLabel?: string;
  noLabel?: string;
  onYes: (o: any) => void;
  onNo: () => void;
}

export const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  show,
  message,
  object,
  title = 'Confirmation',
  yesLabel = 'Oui',
  noLabel = 'Non',
  onYes,
  onNo,
}) => {
  return (
    <Modal show={show} onHide={onNo} centered>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{message}</Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onNo}>
          {noLabel}
        </Button>
        <Button variant="primary" onClick={() => onYes(object)}>
          {yesLabel}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
